export default {
  REPORT_INIT: "REPORT_INIT",
  REPORT_REMOVE: "REPORT_REMOVE",
  REPORT_UPDATE_RESULT: "REPORT_UPDATE_RESULT",
  REPORT_RESET_DATA: "REPORT_RESET_DATA",
};
